import { Pagamento } from 'src/app/model/pagamento.model';

export class NovoPagamento {
    public userEmail: String;
    public pagamento: Pagamento;
}
